import React from 'react';
import PropTypes from 'prop-types';
import MuiAccordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Grid from '@wui/layout/grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import BookGrayIcon from 'icons/svg/book-gray.svg';
import { withStyles } from '@material-ui/core/styles';

const Accordion = withStyles({
  root: {
    border: 'none',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'none',
    },
  },
  expanded: {},
})(MuiAccordion);

const styles = () => ({
  root: {
    width: '100%',
  },
  heading: {
    color: '#39508C',
  },
  divider: {
    margin: '15px 0',
  },
  gridTitle: {
    margin: '24px 0 16px 8px',
  },
  faqTitle: {
    color: '#6B737A',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    marginLeft: '8px',
  },
});

export class FAQBase extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    questions: PropTypes.arrayOf(
      PropTypes.shape({
        question: PropTypes.string.isRequired,
        answer: PropTypes.string.isRequired,
      }),
    ).isRequired,
  };

  state = {
    expanded: false,
  };

  handleChange = panel => (event, isExpanded) => {
    this.setState({ expanded: isExpanded ? panel : false });
  };

  renderQuestion = ({ question, answer }, index) => {
    const { classes } = this.props;
    const { expanded } = this.state;
    const panel = `panel${index + 1}`;

    return (
      <Accordion key={panel} expanded={expanded === panel} onChange={this.handleChange(panel)}>
        <AccordionSummary
          expandIcon={expanded === panel ? <RemoveIcon /> : <AddIcon />}
          aria-controls={`${panel}-content`}
          id={`${panel}-header`}
        >
          <Typography className={classes.heading}>{question}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>{answer}</Typography>
        </AccordionDetails>
      </Accordion>
    );
  };

  render() {
    const { classes, questions } = this.props;

    return (
      <div className={classes.root}>
        <Divider className={classes.divider} />
        <Grid container direction="row" alignItems="center" className={classes.gridTitle}>
          <img alt="FAQs" src={BookGrayIcon} />
          <Typography className={classes.faqTitle}>Related Questions</Typography>
        </Grid>
        {questions.map(this.renderQuestion)}
      </div>
    );
  }
}

export default withStyles(styles)(FAQBase);
